import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

const Tags = ({tags}) => {
    const isSmallScreen = useMediaQuery("sm");
  return (
    <Box
    sx={{
      position: "absolute",
      zIndex: 2,
      bottom: 20,
      left: "20px",
      display: "flex",
      gap: 1,
    }}
  >
    {tags?.map((tag, index) => (
      <Typography
        key={index}
        sx={{
          fontSize: "12px",
          fontWeight: "bold",
          padding:isSmallScreen ? "2px 6px" : "4px 8px",
          borderRadius: "4px",
          color: tag.textColor,
          backgroundColor: tag.bgColor,
          boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
        }}
      >
        {tag.text}
      </Typography>
    ))}
  </Box>
  )
}

export default Tags
